import React from 'react'
import './card-item.style.scss'

const CartItem = ({item: {name, price, imageUrl, quantity}}) => (
  <div className='card-item'>
    <img className='img' src={imageUrl} alt='img'/> 
    <div className='details'>
      <div className='name'>
        {name}
      </div>
      
      <div className='rest'>
        {quantity} × ${price}
      </div>      
    </div>
  </div>
)

export default CartItem